import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackChapterAnalysis } from '../../../../../../apps/frontend/src/redux/slices/packSlice';

export const useChapterAnalysis = (packId, testFilter) => {
  const dispatch = useDispatch();
  const {
    chapterAnalysis: { data, loading, error },
  } = useSelector((state) => state.pack);
  const [page, setPage] = useState(1);

  // Reset page to 1 whenever testFilter or packId changes
  useEffect(() => {
    if (packId) {
      setPage(1);
    }
  }, [testFilter, packId]);

  // Fetch data when packId, testFilter, or page changes
  useEffect(() => {
    if (packId) {
      dispatch(fetchPackChapterAnalysis({ packId, page, testFilter }));
    }
  }, [dispatch, packId, testFilter, page]);

  return { data, loading, error, page, setPage };
};